import { render, staticRenderFns } from "./NotificationsHistory.vue?vue&type=template&id=459c4414&"
import script from "./NotificationsHistory.js?vue&type=script&lang=js&"
export * from "./NotificationsHistory.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports